/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S3_P1Inputs */

const en_guide_json_schema_s3_p1 = /** @type {(inputs: Guide_Json_Schema_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here's a realistic JSON Schema for validating user registration data. It ensures the username is between 3-20 characters, the email is valid, the password meets minimum length requirements, and the age is within a reasonable range.`)
};

const ko_guide_json_schema_s3_p1 = /** @type {(inputs: Guide_Json_Schema_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 등록 데이터를 검증하는 실제적인 JSON Schema 예제입니다. 사용자 이름이 3-20자 사이인지, 이메일이 유효한지, 비밀번호가 최소 길이 요구사항을 충족하는지, 나이가 합리적인 범위 내에 있는지 확인합니다.`)
};

const ja_guide_json_schema_s3_p1 = /** @type {(inputs: Guide_Json_Schema_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー登録データを検証するための実用的なJSON Schemaの例です。ユーザー名が3〜20文字であること、メールが有効であること、パスワードが最小文字数要件を満たしていること、年齢が妥当な範囲内であることを保証します。`)
};

/**
* | output |
* | --- |
* | "Here's a realistic JSON Schema for validating user registration data. It ensures the username is between 3-20 characters, the email is valid, the password me..." |
*
* @param {Guide_Json_Schema_S3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s3_p1 = /** @type {((inputs?: Guide_Json_Schema_S3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s3_p1(inputs)
	if (locale === "ko") return ko_guide_json_schema_s3_p1(inputs)
	return ja_guide_json_schema_s3_p1(inputs)
});